module.exports = __webpack_public_path__ + "media/images/selo-trustvox-22e50071258ff3907cdc27dd91584016.png";